import Vue from 'vue';
import store from './../../store';

const LOOKUP_URL = '/api/v1/lookup-url';

// When the request succeeds
const successLookup = (response) => {
  store.dispatch('getURLLookup', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedLookup = () => {
};

export default (urltoquery) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  const queryinfo = {
    url: urltoquery,
  };
  Vue.$http.post(LOOKUP_URL, queryinfo, axiosOptions)
   .then((response) => {
     successLookup(response);
   })
   .catch((error) => {
     failedLookup(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/lookupurl.js